import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRight, BsWhatsapp } from "react-icons/bs";
import { FiCheckCircle } from "react-icons/fi";

const portfolioImages = [
  { label: "Refined living", position: "0% 0%" },
  { label: "Warm minimalism", position: "50% 0%" },
  { label: "Statement spaces", position: "100% 0%" },
  { label: "Light-led dining", position: "50% 100%" },
];

const promises = [
  {
    title: "One dedicated team",
    text: "Design, furniture and execution coordinated through one accountable team.",
  },
  {
    title: "Clear project scope",
    text: "Selections, estimates and next steps explained before execution begins.",
  },
  {
    title: "Designed for daily life",
    text: "Layouts and materials shaped around how your family actually uses the space.",
  },
];

const HomeTrustSections = () => {
  const whatsappUrl =
    "https://wa.me/919112881916?text=Hi%20Fina%20Interiors%2C%20I%20would%20like%20to%20discuss%20my%20interior%20project.";

  return (
    <>
      <section className="border-y border-gray-200 py-10 md:py-14">
        <div className="site-container mb-7 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase text-[#858653]">
              Design portfolio
            </p>
            <h2 className="mt-2 text-2xl font-semibold text-gray-900 md:text-4xl">
              Spaces shaped around real life
            </h2>
            <p className="mt-3 text-sm leading-6 text-gray-600 md:text-base">
              Thoughtful layouts, composed materials and furniture chosen as one
              complete interior story.
            </p>
          </div>
          <Link
            to="/fina-interiors-home-interior-services"
            className="inline-flex items-center gap-2 text-sm font-bold text-gray-900 hover:text-[#858653]"
          >
            Explore interior services <BsArrowRight aria-hidden="true" />
          </Link>
        </div>

        <div className="site-container grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
          {portfolioImages.map((item) => (
            <div key={item.label} className="relative aspect-[4/3] overflow-hidden bg-gray-100">
              <div
                className="absolute inset-0 bg-cover transition-transform duration-500 hover:scale-105"
                style={{
                  backgroundImage: "url('/IMG_4975.png')",
                  backgroundPosition: item.position,
                  backgroundSize: "300% 200%",
                }}
                role="img"
                aria-label={`${item.label} interior by Fina Interiors`}
              />
              <div className="absolute inset-x-0 bottom-0 bg-black/65 px-4 py-3 text-sm font-semibold text-white">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#f5f3f1] px-4 py-10 md:px-10 md:py-14">
        <div className="mx-auto max-w-6xl">
          <div className="text-center">
            <p className="text-xs font-bold uppercase text-[#b98e80]">
              The Fina promise
            </p>
            <h2 className="mt-2 text-2xl font-semibold text-gray-900 md:text-3xl">
              A calmer way to create your home
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-px overflow-hidden border border-gray-200 bg-gray-200 md:grid-cols-3">
            {promises.map((item) => (
              <div key={item.title} className="bg-white p-6 md:p-8">
                <FiCheckCircle className="text-[#858653]" size={24} aria-hidden="true" />
                <h3 className="mt-5 text-lg font-semibold text-gray-900">{item.title}</h3>
                <p className="mt-2 text-sm leading-6 text-gray-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="grid grid-cols-1 bg-[#20211d] text-white lg:grid-cols-[1.1fr_0.9fr]">
        <div className="flex flex-col justify-center px-5 py-10 md:px-10 md:py-14">
          <p className="text-xs font-bold uppercase text-[#c49a8c]">
            Start a conversation
          </p>
          <h2 className="mt-3 max-w-2xl text-3xl font-semibold md:text-4xl">
            Planning a home that feels unmistakably yours?
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-6 text-gray-300 md:text-base">
            Share your space, timeline and ideas with our Pune design team. We will
            help you identify the right next step.
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#858653] px-5 py-3 text-sm font-bold text-white hover:bg-[#737447]"
            >
              <BsWhatsapp size={18} aria-hidden="true" />
              Chat on WhatsApp
            </a>
            <Link
              to="/get-quote"
              className="inline-flex items-center justify-center gap-2 border border-white/50 px-5 py-3 text-sm font-bold text-white hover:bg-white hover:text-black"
            >
              Request a consultation <BsArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>
        <img
          src="/contact.jpg"
          alt="Fina Interiors consultation"
          className="h-64 w-full object-cover lg:h-full"
          loading="lazy"
        />
      </section>
    </>
  );
};

export default HomeTrustSections;
